import React from 'react';
import format from 'date-fns/format';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import store from '../../store';
const formatDate = dateStr => format(new Date(dateStr), 'dd.MM.yyyy HH:mm');

const colors = [
	'#a4c400',
	'#60a917',
	'#008a00',
	'#00aba9',
	'#1ba1e2',
	'#0050ef',
	'#6a00ff',
	'#aa00ff',
	'#f472d0',
	'#d80073',
	'#a20025',
	'#e51400',
	'#fa6800',
	'#f0a30a',
	'#d8c100',
	'#825a2c',
	'#6d8764',
	'#7a3b3f',
	'#647687',
	'#76608a',
];

@observer
export default class Comments extends React.Component {
	@observable comments;

	constructor(props) {
		super(props);
		this.record = props.record;
		this.init();
	}

	init = async () => {
		const { id } = this.props;
		if (!id) {
			this.loading = false;
			return;
		}
		const comments = await store.model.Comment.find({
			where: { discussionId: id },
			include: ['attachments', 'role'],
		});
		this.comments = comments;
		this.loading = false;
	};

	@action toggleComment = async (e, comment) => {
		comment.publish = e.target.checked;
		await comment.save();
	};
	render() {
		const { id } = this.props;
		if (!id) {
			return (
				<div>
					<h3>Cоздайте обсуждение, чтобы увидеть комментарии </h3>
				</div>
			);
		}
		if (this.comments) {
			if (this.comments.length === 0) {
				return (
					<div>
						<h3>Комментариев пока нет</h3>
					</div>
				);
			}
			return (
				<div className="discussion-edit">
					{this.comments.map(comment => {
						return (
							<div key={comment.id} className="comment">
								<div className="publish">
									<input type="checkbox" checked={comment.publish} onChange={e => this.toggleComment(e, comment)} />
								</div>
								<div className="body">
									<div className="name">
										<span className="date">{formatDate(comment.createdAt)}</span>
										<span style={{ color: colors[comment.roleId] }}> {comment.name}</span>
									</div>
									<div className="text" dangerouslySetInnerHTML={{ __html: comment.text.replace(/\n/g, '<br/>') }} />
									<div>
										{comment.attachments().length > 0 &&
											comment.attachments().map(attach => (
												<p key={`attachment-${attach.id}`}>
													<a download href={attach.downloadFile('filename')} key={`attachment-${attach.id}`}>
														{attach.filename}
													</a>
												</p>
											))}
									</div>
								</div>
							</div>
						);
					})}
				</div>
			);
		}
		return null;
	}
}
